import React, { useEffect, useState, Suspense } from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Flavour } from "venuescanner-js/react/components/VenueSearch/constants";

import classes from "venuescanner-js/react/components/venue-finder/vert/styles.module.scss";
import conciergeHeaderTransitions from "venuescanner-js/react/components/venue-finder/vert/conciergeHeaderTransitions.module.scss";
import { ConfigContext } from "venuescanner-js/react/components/VenueSearch/context";

const VerticalForm = React.lazy(() =>
  import(
    /* webpackChunkName: "vertical-form" */ "venuescanner-js/react/components/venue-finder/vert/VerticalForm"
  )
);
let goToSrpFunction = null;
export const triggerEventID = "vs:concierge-triggered";
const ConciergePage = (props) => {
  const [open, toggleForm] = useState(props?.conciergeCard ? true : false);
  const [thanks, toggleThanks] = useState(false);

  useEffect(() => {
    const toggleFormHandler = () => toggleForm(true);
    window.addEventListener(triggerEventID, toggleFormHandler);
    return () => window.removeEventListener(triggerEventID, toggleFormHandler);
  }, [toggleForm]);

  return (
    <div className="venueSearch-form">
      <TransitionGroup>
        {!thanks && !open && (
          <CSSTransition
            key="welcome"
            classNames={conciergeHeaderTransitions}
            timeout={300}
            unmountOnExit
          >
            <div className={classes.header}>
              <h2 className="vs-concierge-sounds-interesting-title">
                Sounds interesting? Find a venue for free here.
              </h2>
              <p className="vs-concierge-sounds-interesting-desc">
                Fill out our event brief form and leave the rest to us.
              </p>
              <button
                className="concierge-header-button"
                onClick={() => toggleForm(!open)}
              >
                Find me the perfect venue
              </button>
            </div>
          </CSSTransition>
        )}

        {!thanks && open && (
          <CSSTransition
            key="form"
            classNames={conciergeHeaderTransitions}
            timeout={300}
            unmountOnExit
          >
            <Suspense fallback={<vs-loader>One moment please...</vs-loader>}>
              <ConfigContext.Provider
                value={{ ...props, flavour: Flavour.CONCIERGE }}
              >
                <VerticalForm
                  onCompletion={(goToSrp) => {
                    props?.conciergeCard
                      ? props.handleComplete()
                      : (goToSrpFunction = goToSrp);
                    toggleForm(false);
                    toggleThanks(true);
                  }}
                  conciergeCard={
                    props?.conciergeCard ? props.conciergeCard : false
                  }
                />
              </ConfigContext.Provider>
            </Suspense>
          </CSSTransition>
        )}

        {thanks && (
          <CSSTransition
            key="thanks"
            classNames={conciergeHeaderTransitions}
            timeout={300}
            unmountOnExit
          >
            <div className={classes.thankYou}>
              <h2 className={classes.thankYou__title}>Thank you</h2>
              <p>
                One of our concierges will be in contact as soon as they have
                some venue proposals to discuss with you.
              </p>
              {goToSrpFunction && (
                <p>
                  <button
                    type="button"
                    className="vs-button"
                    onClick={goToSrpFunction}
                  >
                    Check our search now
                  </button>
                </p>
              )}
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  );
};

ConciergePage.propTypes = {
  user: PropTypes.string,
  phone: PropTypes.string,
};

export default ConciergePage;
